import { useEffect, useState } from "react";
import { FeedbackContext } from "./FeedbackContext";
import { UserSession } from "@/types/session";
import { useSession } from "@/hooks/useSession";
import { useAuth } from "@/hooks/useAuth";
import { useSearchParams } from "react-router-dom";

const SHOW_FEEDBACK_QUERY_PARAM = "askFeedback";

export interface FeedbackProviderProps {
  children: React.ReactNode;
}

export const FeedbackProvider = ({ children }: FeedbackProviderProps) => {
  const [query, setQuery] = useSearchParams();

  const { userData } = useAuth();

  const { getClosedUnratedSessions } = useSession();
  const [ratedSessionIds, setRatedSessionIds] = useState<UserSession["id"][] | null>(null);

  const showFeedbackModal = (sessionIds: UserSession["id"][]) => {
    setRatedSessionIds(sessionIds);
  };

  const closeFeedbackModal = () => {
    setRatedSessionIds(null);
  };

  useEffect(() => {
    const showFeedback = Boolean(query.get(SHOW_FEEDBACK_QUERY_PARAM));
    if (!userData || !showFeedback) return;

    getClosedUnratedSessions().then((sessions) => {
      setRatedSessionIds(sessions?.map((session) => session.id) || []);
      query.delete(SHOW_FEEDBACK_QUERY_PARAM);
      setQuery(query, { replace: true });
    });
  }, [getClosedUnratedSessions, userData, query, setQuery]);

  return (
    <FeedbackContext.Provider value={{ showFeedbackModal, ratedSessionIds, closeFeedbackModal }}>
      {children}
    </FeedbackContext.Provider>
  );
};
